import React, { Component } from "react";
import ReactQuill from "react-quill";
import NotificationSystem from "react-notification-system";
import {
  Input,
  Form,
  Button,
  Row,
  Col,
  Label,
  Card,
  FormGroup,
  CardBody,
} from "reactstrap";
import Select from "react-select";
import "react-multi-email/style.css";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import * as Server from "../Server";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
class TeamMail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      body: "",
      subject: "",
      fromValue: "",
      teamIds: [],
      showLoader: false,
      teamOptions: [],
      selectedTeams: [],
    };
    this.modules = {
      toolbar: [
        [{ font: [] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ["clean"],
      ],
    };

    this.formats = [
      "font",
      "size",
      "bold",
      "italic",
      "underline",
      "list",
      "bullet",
      "align",
      "color",
      "background",
    ];

    this.rteChange = this.rteChange.bind(this);
  }

  componentDidMount() {
    this.getTeamList();
  }

  getTeamList = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/club/teamlist",
        method: "GET",
      });
      if (response && response.teams.length) {
        let teams = [];
        response.teams.map((team) =>
          teams.push({
            label: team.name,
            value: team._id,
          })
        );
        this.setState({ teamOptions: teams });
        this.setState({ showLoader: false });
      } else {
        this.setState({ showLoader: false });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  sendMail = async (event) => {
    event.preventDefault();
    if (this.state.teamIds.length <= 0) {
      return this.notificationSystem.addNotification({
        message: "Please select team",
        level: "error",
      });
    }

    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/team/sendmail",
        method: "POST",
        data: {
          fromValue: this.state.fromValue,
          subject: this.state.subject,
          body: this.state.body,
          teamIds: this.state.teamIds,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          body: "",
          subject: "",
          teamIds: [],
          fromValue: "",
          selectedTeams: [],
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  rteChange = (content, delta, source, editor) => {
    this.setState({ body: editor.getHTML() });
  };

  handleTeamChange = (Teams) => {
    let teamIds = Teams.map((team) => team.value);
    this.setState((prevState) => ({
      selectedTeams: Teams,
      teamIds: teamIds,
    }));
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Send Mail"
          breadcrumbs={[{ name: "Send Mail", active: true }]}
        >
          <Card className="border-0">
            <CardBody>
              <Row>
                <Col xs={8} lg={5}>
                  <FormGroup>
                    <Label className="font-weight-bold">Select Team:</Label>
                    <div>
                      <Select
                        isMulti
                        closeMenuOnSelect={false}
                        options={this.state.teamOptions || []}
                        value={this.state.selectedTeams}
                        onChange={this.handleTeamChange}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <Form onSubmit={(event) => this.sendMail(event)}>
                <Row>
                  <Col xs={8} lg={5}>
                    <FormGroup>
                      <Label className="font-weight-bold">Email From:</Label>
                      <Input
                        type="text"
                        name="from"
                        placeholder="Enter the Value"
                        required
                        value={this.state.fromValue || ""}
                        onChange={(event) =>
                          this.setState({
                            fromValue: event.target.value,
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={8} lg={5}>
                    <FormGroup>
                      <Label className="font-weight-bold">Email Subject:</Label>
                      <Input
                        type="text"
                        name="Subject"
                        placeholder="Enter the Subject"
                        required
                        value={this.state.subject || ""}
                        onChange={(event) =>
                          this.setState({
                            subject: event.target.value,
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={12} lg={12} xl={12}>
                    <FormGroup>
                      <Label className="font-weight-bold">Message:</Label>
                      <ReactQuill
                        theme="snow"
                        modules={this.modules}
                        formats={this.formats}
                        onChange={this.rteChange}
                        value={this.state.body}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Button type="submit" className="mt-3">
                  Send Mail
                </Button>
              </Form>
            </CardBody>
          </Card>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}

export default TeamMail;
